import { render, staticRenderFns } from "./navbarNew.vue?vue&type=template&id=b39860d6&scoped=true&lang=pug"
import script from "./navbarNew.vue?vue&type=script&lang=js"
export * from "./navbarNew.vue?vue&type=script&lang=js"
import style0 from "./navbarNew.vue?vue&type=style&index=0&id=b39860d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39860d6",
  null
  
)

export default component.exports